import React, { useMemo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { themeSettings } from 'theme';
import Auth from 'utils/auth';

import { ROUTES } from 'constants/RoutePaths';

import PublicHome from 'pages/Public/PublicHome/PublicHome';
import Dashboard from 'pages/Protected/Dashboard/Dashboard';
import SignInRedirect from 'pages/Protected/SignInRedirect/SignInRedirect';
import TrailHome from 'pages/Public/Walks/TrailHome/TrailHome';
import TrailsByQRCode from 'pages/Public/Walks/TrailsByQR/TrailsByQRCode';
import TrailDetail from 'pages/Public/Walks/TrailDetail/TrailDetail';
import TrailCheckinDetail from 'pages/Public/Walks/TrailDetail/TrailCheckinDetail';
import BackendHome from 'pages/Protected/Backend/BackendHome';
import LiveActivities from 'pages/Protected/Backend/LiveActivities/LiveActivities';
import UserProfile from 'pages/Protected/User/UserProfile/UserProfile';
import WelfareCheckSettings from 'pages/Protected/Admin/WelfareCheckSettings/WelfareCheckSettings';
import PageNotFound from 'pages/PageNotFound/PageNotFound';
import RequireAuth from 'features/auth/RequireAuth';
import WelfareCheckLayout from 'layouts/Public/WelfareCheckLayout/WelfareCheckLayout';
import WalkerResponse from 'pages/Public/WelfareCheck/WalkerResponse/WalkerResponse';
import ContactResponse from 'pages/Public/WelfareCheck/ContactResponse/ContactResponse';

const AppRoutes = () => {
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);

  return (
    <div className="flex flex-col flex-1 h-full">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Routes>
          <Route exact path="/" element={<Navigate to="/home" replace />} />
          <Route path={ROUTES.HOME} element={<Dashboard />}>
            <Route index element={<PublicHome />} />
          </Route>
          <Route>
            <Route
              path={ROUTES.SIGN_IN_REDIRECT}
              element={<SignInRedirect />}
            />
            <Route exact path="*" element={<PageNotFound />} />
          </Route>
          <Route path={ROUTES.TRAIL_HOME} element={<Dashboard />}>
            <Route index element={<TrailHome />} />
          </Route>
          <Route path={ROUTES.TRAIL_BY_QR_CODE} element={<Dashboard />}>
            <Route index element={<TrailsByQRCode />} />
          </Route>
          <Route path={ROUTES.TRAIL_DETAIL} element={<Dashboard />}>
            <Route index element={<TrailDetail />} />
          </Route>
          <Route path={ROUTES.TRAIL_CHECKIN_DETAIL} element={<Dashboard />}>
            <Route index element={<TrailCheckinDetail />} />
          </Route>
          <Route path={ROUTES.PROFILE} element={<Dashboard />}>
            <Route index element={<UserProfile />} />
          </Route>
          <Route path={ROUTES.BACKEND_HOME} element={<Dashboard />}>
            <Route index element={<BackendHome />} />
          </Route>
          <Route element={<RequireAuth allowedRoles={['Admin', 'SafetyMonitor']} />}>
            <Route path={ROUTES.LIVE_ACTIVITIES} element={<Dashboard />}>
              <Route index element={<LiveActivities />} />
            </Route>
          </Route>
          <Route element={<RequireAuth allowedRoles={['Admin']} />}>
            <Route path={ROUTES.ADMIN_WELFARE_CHECK_SETTINGS} element={<Dashboard />}>
              <Route index element={<WelfareCheckSettings />} />
            </Route>
          </Route>
          <Route path={ROUTES.WELFARE_CHECK_WALKER} element={<WelfareCheckLayout />}>
            <Route index element={<WalkerResponse />} />
          </Route>
          <Route path={ROUTES.WELFARE_CHECK_CONTACT} element={<WelfareCheckLayout />}>
            <Route index element={<ContactResponse />} />
          </Route>
        </Routes>
      </ThemeProvider>
    </div>
  );
};

export default AppRoutes;
